export const hgujarati = {
  //home
  "g1": "ગુજરાત રાજ્ય કૃષિ માર્કેટિંગ,",
  "g11": "બોર્ડ (ગુજરાત મંડી બોર્ડ, GSAMB)",
  "g_home": " ગુજરાત રાજ્ય કૃષિ માર્કેટિંગ બોર્ડ (ગુજરાત મંડી બોર્ડ, GSAMB) ની સ્થાપના કૃષિ પેદાશોની ખરીદી, વેચાણ અને સંગ્રહનું નિયમન અને સંચાલન કરવા માટે કરવામાં આવી હતી. તે ખેડૂતો, વેપારીઓ અને ખરીદદારો માટે વાજબી વેપાર પ્રથાઓ સુનિશ્ચિત કરે છે. GSAMB સરળ પુરવઠા શૃંખલા જાળવવા માટે કૃષિ, બાગાયતી, પશુપાલન અને વન ઉત્પાદનોના માર્કેટિંગની દેખરેખ રાખે છે. તે મિલકતોની માલિકી અને સંચાલન કરવાની સત્તા ધરાવતી સ્વતંત્ર સંસ્થા તરીકે કાર્ય કરે છે.",
  "q_link": "ઝડપી લિંક્સ",
  "trader_reg": "વેપારી નોંધણી",
  "panel_reg": " પેનલ એન્જિનિયર નોંધણી",
  "gca_reg": "સામાન્ય કમિશન એજન્ટ નોંધણી",
  "tra_desc": "વેપારી તરીકે નોંધણી કરો અને લાઇસન્સ મેળવો",
  "panel_desc": "પેનલ એન્જિનિયર તરીકે નોંધણી કરો અને લાઇસન્સ મેળવો",
  "gca_desc": "GCA તરીકે નોંધણી કરો અને લાઇસન્સ મેળવો",
  "g2": "કૃષિ માર્કેટિંગ અને ગ્રામીણ નાણાકીય વ્યવસ્થા નિયામક",
  "logout": "લોગઆઉટ",
  "lang": "ભાષા",
  "main": "મુખ્ય",
  "home": "ઘર",
  "tra_login": "ટ્રેડર લોગીન",
  "gc_login": "સામાન્ય કમિશન એજન્ટ લોગીન",
  "spon_login": "સ્પોન્સર લોગીન",
  "pa_login": "પેનલ એન્જિનિયર લોગીન",
  "dr_login": "જિલ્લા રજિસ્ટ્રાર લોગીન",
  "ap_login": "એપીએમસી લોગીન",
  "ho_login": "હેડ ઓફિસર લોગીન",
  "about": "અમારા વિશે",
  "quick_links": "ઝડપી લિંક્સ",
  "get_touch": "સંપર્કમાં રહો",
  "gallery": "ગેલેરી",
  "terms_conditions": "નિયમો અને શરતો",
  "privacy_policy": "ગોપનીયતા નીતિ",
  "announcement": "જાહેરાત",
  "readMore": "વધુ વાંચો",
  "contactAddress": "બ્લોક નં.13, બીજો માળ, ડો.જીવરાજ મહેતા ભવન, ગાંધીનગર.",
  "ourGallery": "અમારી ગેલેરી",
  "totAPMCs": "કુલ APMC",
  "totComm": "કુલ કોમોડિટીઝ",
  "totDist": "કુલ જિલ્લાઓ",
  "totTal": "કુલ તાલુકાઓ",

  "aboutIntro1": 'ગુજરાત રાજ્યમાં કુલ ૪૦૬ મંડી બજારો છે જેમાં ૨૧૪ મુખ્ય યાર્ડ અને ૧૯૨ પેટા-યાર્ડ તાલુકા મથકો અને અન્ય મુખ્ય વેપાર સ્થળોએ સ્થિત છે. આ સ્થળોએ, વાછરડાના ખેત પેદાશોના વેચાણનું સંચાલન ગુજરાત ફાર્મ માર્કેટ એક્ટ ૧૯૬૩ હેઠળ કરવામાં આવે છે, તેના સંચાલન માટે ફાર્મ પ્રોડ્યુસ માર્કેટ સમિતિઓની રચના કરવામાં આવી છે. સામાન્ય રીતે દરેક તાલુકા મથકમાં ખેત પેદાશોના ખરીદી અને વેચાણ માટે એક જાહેર મુખ્ય સંગઠન હોય છે અને તે સ્થળે બજાર સમિતિની રચના કરવામાં આવે છે. જેથી ખેડૂતો તેમનો માલ સીધો બજારમાં લાવી શકે અને હરાજી દ્વારા વેચી શકે અને વાજબી ભાવે અને વાજબી કિંમતે તેમનો માલ મેળવી શકે.',
  
  "aboutIntro2": 'વર્ષ ૨૦૨૩-૨૪ એટલે કે ૩૧-૩-૨૦૨૪ સુધીમાં, ગુજરાત રાજ્યમાં કુલ ૨૨૪ બજાર સમિતિઓની રચના કરવામાં આવી છે. અને રાજ્યનો સમગ્ર વિસ્તાર બજાર અધિનિયમ હેઠળ આવરી લેવામાં આવ્યો છે.',
  "aboutIntro3": 'રાજ્યના આદિવાસી વિસ્તારોમાં કુલ ૫૧ બજાર સમિતિઓની રચના કરવામાં આવી છે. તેમાં ૪૫ મુખ્ય યાર્ડ અને ૭૩ પેટા યાર્ડ છે, કુલ ૧૧૮ મંડી બજારો છે. વધુમાં, આદિવાસી વિસ્તારોમાં ૧૨૯ "હાટ બજારો" છે.',

  "aboutIntro4":"બજાર સમિતિનું બંધારણ",
  "aboutIntro5":"બજાર અધિનિયમની કલમ-૧૧ હેઠળ, દરેક બજાર સમિતિમાં નીચેના સભ્યો હશે.",
  "aboutIntro6":"દસ ખેડૂત સભ્યો",
  "aboutIntro7":"ચાર ટ્રેડિંગ સભ્યો",
  "aboutIntro8":"જો બજાર વિસ્તારમાં આવેલી અને સામાન્ય લાઇસન્સ ધરાવતી સહકારી ખરીદ-વેચાણ મંડળીઓની સંખ્યા બે કરતા વધુ ન હોય તો એક પ્રતિનિધિ, જો બે કરતા વધુ હોય તો બે પ્રતિનિધિઓ",
  "aboutIntro9":"મુખ્ય બજાર ચોરસ જ્યાં સ્થિત છે ત્યાં સ્થાનિક સત્તાવાળાના નિયુક્ત સભ્ય.",
  "aboutIntro10":"સરકારના બે નિયુક્ત સભ્યો.",
  "aboutIntro11":"આ સંદર્ભમાં (૧) બજાર વિસ્તારમાં કૃષિ ધિરાણ આપતી સહકારી મંડળીઓની વ્યવસ્થાપન સમિતિઓના સભ્યો દ્વારા ચૂંટાયેલા દસ ખેડૂતો. (૨) સામાન્ય લાઇસન્સ પ્રાપ્ત વેપારીઓ પોતાનામાંથી ચાર સભ્યોની પસંદગી કરે છે",

  "missionAndVision":"મિશન અને વિઝન",
  "missionAndVisionDesc":"આગામી 5 વર્ષમાં કૃષિ અને બજાર ક્ષેત્રમાં પ્રગતિનું વિઝન અને મિશન",

  "missVis1":"રાજ્યમાં ૨૨૬ તાલુકાઓમાં ૨૦૭ બજાર સમિતિઓ કાર્યરત છે. જેમાં ૧૯૯ મુખ્ય વોર્ડ અને ૧૯૧ પેટા-યાર્ડ મળીને કુલ ૪૦૦ બજારો છે. છેલ્લા પાંચ વર્ષથી રાજ્ય સરકારને વિવિધ યોજનાઓ દ્વારા રૂ. ૧૧૧.૦૮ કરોડ મળ્યા છે, માળખાકીય સુવિધાઓ ઉપરાંત, આ બજાર સમિતિઓમાં આધુનિક સુવિધાઓનું નિર્માણ કરવામાં આવી રહ્યું છે, આજે આ બજાર સમિતિઓમાં કૃષિ ઉત્પાદન ત્રણ ગણું વધ્યું છે અને વધુને વધુ ખેડૂતો બજાર સમિતિઓના યાર્ડનો ઉપયોગ કરી રહ્યા છે, જેના કારણે તેમને સારા અને વાજબી ભાવ મળી રહ્યા છે.",

  "missVis2":"બજાર ક્ષેત્રમાં આવનારા ફેરફારો સાથે તાલમેલ રાખવા અને બજાર ક્ષેત્રના વિકાસ અને વૈશ્વિકરણને કારણે સર્જાયેલી સ્પર્ધાત્મક પરિસ્થિતિને અનુરૂપ, રાજ્ય સરકારે વર્ષ 2007 માં કૃષિ ઉત્પાદન બજાર અધિનિયમમાં સુધારો કરીને ખાનગી બજાર, ઇ-બજાર, ખેડૂત ગ્રાહક બજાર, સામાન્ય લાઇસન્સ, કરાર ખેતી, ખાસ બજારનો સમાવેશ કર્યો, જેમાં મહત્વપૂર્ણ જોગવાઈઓ કરવામાં આવી છે અને તેના કારણે, બજાર ક્ષેત્રમાં ઘણા ફેરફારોનો સીધો લાભ રાજ્યના ખેડૂતોને થયો છે. જોકે, બજારને હજુ ઘણું કરવાનું બાકી છે, જે આગામી પાંચ વર્ષમાં થવાનું છે.",

    "missVis3":"ગુજરાત રાજ્યની તમામ બજાર સમિતિઓ તેમના તમામ મુખ્ય અને ગૌણ કૃષિ ઉત્પાદનોનું ગ્રેડિંગ, સૉર્ટિંગ અને મૂલ્યવર્ધન કરી શકશે અને તેનું વેચાણ કરી શકશે.",

    "missVis4":"બજાર સમિતિના સ્તરે બજાર સમિતિ દ્વારા સંચાલિત મોલ/રિટેલ આઉટલેટની સ્થાપના.",

    "missVis5":"“ઓર્ગેનિક ખેતી અને કુદરતી ખેતી માટે બજાર વ્યવસ્થા”",

    "missVis6":"વર્તમાન સમયમાં, રાસાયણિક ખાતરો અને જંતુનાશકોના ઉપયોગને કારણે, ખાદ્ય પદાર્થોની ગુણવત્તા ઘટી રહી છે, શરીરમાં પોષક તત્વોનો અભાવ છે, બીપી, ડાયાબિટીસ, કોલેસ્ટ્રોલ, સંધિવા, ઓસ્ટીયોપોરોસિસ, તણાવ, હતાશા, એનિમિયા જેવા વિવિધ પ્રકારના ચેપી રોગોએ ભરડો લીધો છે અને વિશ્વ આરોગ્ય સંગઠન આ રોગો અંગે ચિંતિત છે. આવા સંજોગોમાં, સ્વચ્છ અને સાત્વિક એટલે કે સંતુલિત અને સંપૂર્ણ આહાર તરફનો ઝુકાવ વધ્યો છે, અને તેના કારણે, આજે રાજ્યના પ્રગતિશીલ ખેડૂતો ઓર્ગેનિક ખેતી તરફ વળી રહ્યા છે અને જ્યારે ઓર્ગેનિક ખેતી ક્ષેત્રે મોટી ક્રાંતિ આવી રહી છે, ત્યારે આ ખેતીમાંથી ઉત્પન્ન થતી પેદાશો ખેત પેદાશો માટે સ્વસ્થ બજાર પણ પૂરું પાડે છે.",

    "missVis7":"સરકાર દ્વારા તે પ્રકારનું આયોજન કરવામાં આવ્યું છે, જેમાં રાજ્ય બજાર સમિતિઓએ આ માટે વેચાણ વ્યવસ્થાને પ્રાથમિકતા આપવાનું નક્કી કર્યું છે, જેમાં રાજ્ય સરકાર સંગઠિત બજાર સમિતિના સ્તરે ઉત્પાદક ખેડૂતો, ખરીદદારો, વેપારીઓ અને ગ્રાહકોના સંકલન સાથે સંબંધિત છે, અને નજીકના ભવિષ્યમાં ખેડૂતો અને વેપારીઓને સીધો ફાયદો થાય તે માટે આવી વ્યવસ્થા સ્થાપવાના પ્રયાસો ચાલી રહ્યા છે.",

    "missVis8":"ખેડૂતોના મોલની સ્થાપના",
    "missVis9":"જ્યારે ખેડૂતો પોતાનો ખેત ઉપજ લઈને બજાર સમિતિમાં વેચાણ માટે આવે છે, ત્યારે વેચાણ પછી જે પૈસા તેમના હાથમાં આવે છે, તે તેમને જીવનજરૂરી ચીજવસ્તુઓ ખરીદવા અને ખેતી માટે ઉપયોગી વસ્તુઓ ખરીદવા માટે અન્ય બજારોમાં જવું પડે છે. ઘણી વખત ખેડૂતોને આ સમયે બીજા દિવસે જે નથી મળતું તે ખરીદવા માટે પાછા આવવું પડે છે. રાજ્ય સરકાર બજાર સમિતિના મુખ્ય આંગણામાં એક મોલ સ્થાપવાનું પણ વિચારી રહી છે, જેને ધ્યાનમાં રાખીને ખેડૂત જીવનજરૂરી વસ્તુઓ જેમ કે ઓજારો, ખાતર, બીજ, જંતુનાશકો વગેરે જોઈ શકે. આગામી પાંચ વર્ષમાં એવું વાતાવરણ બનાવવાનું આયોજન કરવામાં આવ્યું છે કે જ્યાં ખેડૂતો નો પ્રોફિટ-નો લોસ ધોરણે પોતાનો પાક વેચી શકે, અવલોકન કરી શકે અને ખરીદી કરી શકે અને રાજ્યની બજાર સમિતિનો 50% હિસ્સો રાજ્ય સરકારનું નામ છે.",

  "glimplseOfAchi": "ગુજરાત સરકાર દ્વારા કરવામાં આવેલી બધી સિદ્ધિઓ અને કાર્યોની ઝલક",
  "contact": "અમારો સંપર્ક કરો",
  "market": "બજાર દર",
  "Scheme": "યોજના",
  "doa": "કૃષિ વિભાગ",
  "goi": "ગુજરાત સરકાર",
  "empower": "ન્યાયસંગત વેપાર દ્વારા ખેડૂતોને સશક્ત બનાવવું",
  "sub_empower": "કૃષિ પ્રથાઓને પ્રોત્સાહન આપતા ખેડૂતોને બજારો સાથે જોડવું, પારદર્શકતા સુનિશ્ચિત કરવી અને ટકાઉ કૃષિ પ્રથાઓને પ્રોત્સાહન આપવું.",
  "reg_as_trader": "વેપારી તરીકે નોંધણી કરો",
  "view_market_rate": "બજાર દર જુઓ",
  "directorInfo":"માર્કેટિંગ અને ગ્રામીણ નાણાં નિયામક",
  "directorParaInfo":"ગુજરાત રાજ્ય કૃષિ માર્કેટિંગ બોર્ડ (ગુજરાત મંડી બોર્ડ, GSAMB) ની સ્થાપના કૃષિ પેદાશોની ખરીદી, વેચાણ અને સંગ્રહનું નિયમન અને સંચાલન કરવા માટે કરવામાં આવી હતી. તે ખેડૂતો, વેપારીઓ અને ખરીદદારો માટે વાજબી વેપાર પ્રથાઓ સુનિશ્ચિત કરે છે. GSAMB સરળ પુરવઠા શૃંખલા જાળવવા માટે કૃષિ, બાગાયતી, પશુપાલન અને વન ઉત્પાદનોના માર્કેટિંગનું નિરીક્ષણ કરે છે. તે મિલકતોની માલિકી અને સંચાલન કરવાની સત્તા ધરાવતી સ્વતંત્ર સંસ્થા તરીકે કાર્ય કરે છે.",

  "AboutUs": 'વિભાગ વિશે',
  "scheme_forms": "યોજનાઓ અને ફોર્મ્સ",
  "introduction": "પરિચય",
  "scheme_desc": "સરકારી યોજનાઓ અને અન્ય અરજી ફોર્મ માટે અરજી કરો.",

  "about_since_year": "૧૯૬૩ થી",
  "about_market_commitee": "કૃષિ પેદાશ બજાર સમિતિ",
  "about_us_content_1": `કૃષિ ઉત્પાદન બજાર સમિતિ (APMC) ગુજરાતના કૃષિ
                      અર્થતંત્રનો પાયાનો આધારસ્તંભ રહી છે. અમારું મુખ્ય ધ્યેય એક ન્યાયી, પારદર્શક
                      અને સ્પર્ધાત્મક વેપાર વાતાવરણ બનાવીને અમારા ખેડૂતોના હિતોનું રક્ષણ કરવાનું છે. અમે એક સંગઠિત માર્કેટિંગ સિસ્ટમ માટે સમર્પિત છીએ જે ખાતરી કરે છે કે દરેક
                      ખેડૂતને તેમની મહેનતનું સાચું મૂલ્ય મળે.`,
  "about_us_content_2": `APMC ગુજરાત આધુનિક માર્કેટ યાર્ડ્સના રાજ્યવ્યાપી નેટવર્કનું સંચાલન કરે છે જે આર્થિક 
                      પ્રવૃત્તિના મહત્વપૂર્ણ કેન્દ્ર તરીકે સેવા આપે છે. અમે આવશ્યક માળખાકીય સુવિધાઓ પૂરી પાડીએ છીએ - જેમાં વૈજ્ઞાનિક સંગ્રહ, ઇલેક્ટ્રોનિક વજન પ્રણાલીઓ, 
                      અને હરાજી પ્લેટફોર્મનો સમાવેશ થાય છે. વેપારીઓ અને એજન્ટો સહિત તમામ બજાર કાર્યકર્તાઓને લાઇસન્સ અને નિયમન કરીને, 
                      અમે ખાતરી કરીએ છીએ કે દરેક વ્યવહાર પારદર્શક અને નૈતિક હોય, સપ્લાય ચેઇનમાં અચળ વિશ્વાસનું નિર્માણ થાય.`,
  "about_us_content_3": `ભવિષ્ય તરફ નજર કરીએ તો, અમે નવીનતા દ્વારા, ખાસ કરીને 
                      e-NAM (ઈલેક્ટ્રોનિક નેશનલ એગ્રીકલ્ચર માર્કેટ) પ્લેટફોર્મ દ્વારા, અમારા ખેડૂતોને સશક્ત બનાવવા માટે પ્રતિબદ્ધ છીએ.`,

  "minister_header1": 'મુખ્ય સરકારી અધિકારીઓ',
  "minister_header2": 'સમગ્ર ગુજરાતમાં કૃષિ બજારના વિકાસને આગળ ધપાવતા સમર્પિત નેતાઓને મળો.',

  "minister_Bhupendra": "શ્રી ભૂપેન્દ્ર પટેલ",
  "minister_Bhupendra_details1": `માનનીય મુખ્યમંત્રીશ્રી`,
  "minister_Bhupendra_details2": `ગુજરાત સરકાર`,

  "minister_Rameshbhai": "શ્રી રમેશભાઈ ભુરાભાઈ કટારા",
  "minister_Rameshbhai_details1": `માનનીય રાજ્ય કૃષિ અને ખેડૂત કલ્યાણ મંત્રી,`,
  "minister_Rameshbhai_details2": `સહકાર, પશુપાલન અને ગાય સંવર્ધન`,

  "minister_Jitubhai": "શ્રી જીતુભાઈ વાઘાણી",
  "minister_Jitubhai_details1": `માનનીય કૃષિ અને ખેડૂત કલ્યાણ મંત્રી,`,
  "minister_Jitubhai_details2": `સહકાર, પશુપાલન, ગાય સંવર્ધન, માછીમારી`,

  "minister_Arunkumar": "શ્રી અરુણકુમાર એમ સોલંકી, આઈએએસ",
  "minister_Arunkumar_details1": `ગુજરાત રાજ્ય વેરહાઉસિંગના મેનેજિંગ ડિરેક્ટર`,
  "minister_Arunkumar_details2": `કોર્પોરેશન`,

  "minister_Pandya": "શ્રી એમ.પી. પંડ્યા, આઈએએસ",
  "minister_Pandya_details1": `રજિસ્ટ્રાર, સહકારી મંડળીઓ,`,
  "minister_Pandya_details2": `ગુજરાત સરકાર`,

  "minister_Patel": 'શ્રી એચ.આર.પટેલ',
  "minister_Patel_details1": `એગ્રીકલ્ચર માર્કેટીંગ નિયામક`,
  "minister_Patel_details2": `અને ગ્રામીણ ફાઇનાન્સ`,

  "g_map_1": 'નો વહીવટી નકશો',
  "g_map_2": 'APMC કવરેજ',
  "g_map_3": 'ગુજરાત',
  "g_map_4": '૩૩ દેશોમાં ૧૪૫+ કૃષિ બજારોનું અન્વેષણ કરો',
  "g_map_5": 'ગુજરાતના જિલ્લાઓ.',

  "pdf_page_headers1": 'કાયદા, નિયમો અને સુધારા',
  "pdf_page_headers2": 'ગુજરાતમાં કૃષિ બજારોને સંચાલિત કરતા સત્તાવાર સરકારી દસ્તાવેજો મેળવો',
  "pdf_page_Act_1963": 'ગુજરાત કૃષિ ઉત્પાદન બજાર અધિનિયમ ૧૯૬૩',
  "pdf_page_Act_1963_content": 'ગુજરાત કૃષિ ઉત્પાદન બજાર અધિનિયમ, ૧૯૬૩ (૩૦ જૂન ૨૦૦૬ સુધી સુધારેલ)',
  "pdf_page_Legal_Amendments": 'કાનૂની સુધારા',
  "pdf_page_Legal_Amendments_content1": 'ગુજરાત કૃષિ ઉત્પાદન બજારો (સુધારો) અધિનિયમ, ૨૦૧૫',
  "pdf_page_Legal_Amendments_content2": 'ગુજરાત કૃષિ ઉત્પાદન બજારો (સુધારો) અધિનિયમ, ૨૦૧૫',
  "pdf_page_Legal_Amendments_content3": 'ગુજરાત કૃષિ ઉત્પાદન (સુધારો) અધિનિયમ ૨૦૨૦',
  "pdf_page_Legal_Amendments_content4": 'ગુજરાત કૃષિ ઉત્પાદન (સુધારો) અધિનિયમ ૨૦૨૩',
  "pdf_page_APMC_Rules": 'APMC નિયમો',
  "pdf_page_APMC_Rules_content1": 'ગુજરાત સહકારી મંડળીઓના નિયમો ૧૯૬૫ (૩૦ સપ્ટેમ્બર ૧૯૯૧ સુધી સુધારેલા)',
  "pdf_page_General_Circulars": 'સામાન્ય પરિપત્રો',
  "pdf_page_General_Circulars_content1": 'દાન પરિપત્ર',
  "pdf_page_General_Circulars_content2": 'સેક્રેટરી વિસ્તરણ',
  "pdf_page_General_Circulars_content3": 'પરિપત્ર ચેકલિસ્ટ (છેલ્લે અપડેટ: ૧૮/૦૬/૨૦૨૫)',
  "pdf_page_General_Circulars_content4": 'ડ્ડા પ્રથા પરિપત્ર - I',
  "pdf_page_General_Circulars_content5": 'કડ્ડા પ્રથા પરિપત્ર - II',
  "pdf_page_General_Circulars_content6": 'યોજનાનો પરિપત્ર',
  "pdf_page_General_Circulars_content7": 'APMC ઓડિટ પરિપત્ર',
  "pdf_page_General_Circulars_content8": 'વર્ગીકરણ પરિપત્ર-ગોળાકાર',
  "view_pdf": 'પીડીએફ જુઓ',

  "slider1A": "કૃષિમાં ડિજિટલ પરિવર્તન",
  "slider1B": "સમગ્ર ભારતમાં પારદર્શક અને કાર્યક્ષમ કૃષિ બજારો બનાવવા માટે ટેકનોલોજીનો ઉપયોગ કરવો",
  "slider2A": "ખેડૂતોને વાજબી ભાવો સાથે સશક્ત બનાવવું",
  "slider2B": "ખેડૂતોને તેમના ઉત્પાદનનું શ્રેષ્ઠ મૂલ્ય મળે તે સુનિશ્ચિત કરતી પારદર્શક કિંમત પદ્ધતિ",
  "slider3A": "સારા વેપાર માટે આધુનિક ઈન્ફ્રાસ્ટ્રક્ચર",
  "slider3B": "વેપાર અને સંગ્રહ માટે અદ્યતન સુવિધાઓ સાથે અત્યાધુનિક માર્કેટ યાર્ડ્સ",
  "slider4A": "ગુણવત્તા ખાતરી અને ધોરણો",
  "slider4B": "ગુણવત્તાયુક્ત ઉત્પાદન ગ્રાહકો સુધી પહોંચે તે સુનિશ્ચિત કરતી પ્રમાણિત પરીક્ષણ પ્રયોગશાળાઓ",
  "register_now": "હમણાં નોંધણી કરો",
  "know_more": "વધુ જાણો",
  "trader": "વેપારી",
  "panel_engineer": "પેનલ એન્જિનિયર",
  "gca": "સામાન્ય કમિશન એજન્ટ",
  "docs_required_title": "નોંધણી માટે જરૂરી દસ્તાવેજો",
  "docs_required_subtitle": "નોંધણી માટે જરૂરી દસ્તાવેજો",
  "note_label": "નોંધ:",
  "note_text": "નીચેના દરેક વિભાગમાંથી કોઈ એક દસ્તાવેજ જરૂરી છે.",
  "doc_identity": "ઓળખ પુરાવો: ",
  "doc_identity_options": "આધાર કાર્ડ / ડ્રાઇવિંગ લાઇસન્સ / પાસપોર્ટ / મતદાર ઓળખપત્ર / પાન કાર્ડ",
  "doc_address": "સરનામાનો પુરાવો: ",
  "doc_address_options": "આધાર કાર્ડ / ડ્રાઇવિંગ લાઇસન્સ / પાસપોર્ટ / મતદાર ઓળખપત્ર / પાન કાર્ડ / ડોમીસાઇલ / વીજળી બિલ",
  "doc_dob": "જન્મતારીખનો પુરાવો: ",
  "doc_dob_options": "પાસપોર્ટ / મતદાર ઓળખપત્ર / પાન કાર્ડ / જન્મ પ્રમાણપત્ર / ૧૦મું માર્કશીટ",
  "close_button": "બંધ કરો / Close",
  "proceed_button": "આગળ વધો / Proceed",
  "profiles":"પ્રોફાઇલ્સ",
}